import React from "react"
import { Flex, Link } from "@chakra-ui/react"
import { Link as GatsbyLink } from "gatsby"
import DropdownMenu from "../dropdown-menu"
import MenuLink from "./menu-link"
import { sections, summit, login, medium, compact, mobile } from "./menu"

const button = {
  display: "inline-flex",
  alignItems: "center",
  height: "52px",
  px: "16px",
  borderRadius: "4px",
  fontSize: "16px",
  whiteSpace: "nowrap",
  [medium]: { px: "12px", fontSize: "15px" },
  [compact]: { fontSize: "14px" },
}

const styles = {
  menu: {
    display: "flex",
    alignItems: "center",
    gap: "22px",
    [medium]: { gap: "12px" },
    [compact]: { gap: "10px" },
    [mobile]: { display: "none" },
  },
  "dropdown-menu": {
    "menu-button": {
      height: "auto",
      py: "6px",
      fontSize: "14px",
      lineHeight: "1.75",
      letterSpacing: "0.15px",
      whiteSpace: "nowrap",
      _hover: { color: "#129459" },
      [compact]: {
        fontSize: "13px",
        "& .chakra-button__icon": { marginStart: "6px" },
      },
    },
    "menu-list": {
      height: "auto",
      minWidth: "260px",
      border: "1px solid #E2E8F0",
    },
    "menu-item": {
      height: "auto",
      p: 0,
      borderRadius: "3px",
      "&:hover,&:focus": { bg: "#F4F4F4" },
    },
  },
  "dropdown-link": {
    display: "block",
    width: "100%",
    px: "0.8rem",
    py: "0.4rem",
    color: "#041424",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.1px",
    whiteSpace: "nowrap",
    _hover: { color: "#041424", textDecoration: "none" },
  },
  link: {
    color: "#041424",
    fontSize: "14px",
    letterSpacing: "0.15px",
    whiteSpace: "nowrap",
    _hover: { color: "#129459", textDecoration: "none" },
    [compact]: { fontSize: "13px" },
  },
  "login-button": {
    ...button,
    bg: "white",
    border: "1px solid #D0D5DD",
    color: "#344054",
    _hover: { color: "#344054", textDecoration: "none" },
  },
  "talk-button": {
    ...button,
    bg: "#129459",
    color: "white",
    fontWeight: 600,
    _hover: { bg: "#0E7748", color: "white", textDecoration: "none" },
  },
}

const activeStyle = { color: "#129459", fontWeight: 600 }

const DesktopMenu = () => (
  <Flex sx={styles.menu}>
    {sections.map(section => (
      <DropdownMenu
        key={section.title}
        styles={styles["dropdown-menu"]}
        title={section.title}
        autoSelect={false}
      >
        {section.links.map(link => (
          <MenuLink
            key={link.label}
            link={link}
            activeStyle={activeStyle}
            sx={styles["dropdown-link"]}
          />
        ))}
      </DropdownMenu>
    ))}
    <MenuLink link={summit} sx={styles.link} />
    <MenuLink link={login} sx={styles["login-button"]} />
    <Link as={GatsbyLink} to="/contact-us/" sx={styles["talk-button"]}>
      Let's Talk
    </Link>
  </Flex>
)

export default DesktopMenu
